import type { ProductLabResult } from "@/domains/products/models/types";
import { focusRing, icons } from "@/ui";

type CertificateOfAnalysisRowProps = {
  labResult: ProductLabResult;
};

export const CertificateOfAnalysisRow = ({ labResult }: CertificateOfAnalysisRowProps) => {
  return (
    <div className="flex flex-col justify-between gap-2 border-b border-line py-5 sm:flex-row sm:items-center">
      <span>{labResult.name}</span>
      <a
        className={`flex min-h-11 w-fit items-center gap-2 rounded-md font-semibold underline underline-offset-4 transition-colors hover:text-accent ${focusRing}`}
        href={labResult.certificate_url}
        rel="noreferrer"
        target="_blank"
      >
        <span>Download Link</span>
        <icons.ArrowTopRightOnSquareIcon aria-hidden="true" className="w-5 shrink-0" />
      </a>
    </div>
  );
};
